<!--<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">
    </div>
    <div class="content-body">
      <section class="flexbox-container">
        <div class="col-12 d-flex align-items-center justify-content-center">
          <div class="col-md-4 col-10 box-shadow-2 p-0">
            <div class="card border-grey border-lighten-3 px-1 py-1 m-0">
              <div class="card-title text-center">
                <img src="assets/custom/images/abg/abglogo512.png" alt="branding logo">
              </div>
              <div class="card-content">-->
<!--*ngIf="otpSent && !otpVerified"-->
<!--<div>
  <form [formGroup]="otpForm" (ngSubmit)="verifyOtp()">

      <input type="text" class="form-control" placeholder="Enter OTP" formControlName="otp">
    <br />
    <br />
    <button type="submit" [disabled]="otpForm.invalid" class="btn btn-primary">
      Verify OTP
    </button>
  </form>-->
<!--<p *ngIf="errorMessage">{{ errorMessage }}</p>-->
<!--</div>-->
<!--<div *ngIf="otpVerified">
  OTP verified successfully! Now you can reset your password.
</div>-->
<!--</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>-->

<div class="vo-wrap">
  <div class="vo-card">
    <h1 class="vo-title">Enter verification code</h1>
    <p class="vo-sub" *ngIf="target">We sent a code to <strong>{{ target }}</strong>.</p>

    <div *ngIf="errorMessage" class="vo-alert vo-alert--error" role="alert">{{ errorMessage }}</div>
    <div *ngIf="successMessage" class="vo-alert vo-alert--ok" role="status">{{ successMessage }}</div>

    <form *ngIf="!verified" [formGroup]="form" (ngSubmit)="submit()" novalidate>
      <div class="vo-field">
        <label for="vo-code">Verification code</label>
        <input id="vo-code"
               type="text"
               formControlName="code"
               class="vo-input"
               [class.vo-input--invalid]="f.code.touched && f.code.errors"
               placeholder="Enter the code"
               autocomplete="one-time-code"
               [disabled]="!target" />
        <div class="vo-error" *ngIf="f.code.touched && f.code.errors">
          <span *ngIf="f.code.errors.required">Verification code is required.</span>
        </div>
      </div>

      <button type="submit" class="vo-btn vo-btn--primary" [disabled]="loading || !target">
        {{ loading ? 'Verifying…' : 'Verify' }}
      </button>

      <button type="button" class="vo-btn vo-btn--link" (click)="resend()" [disabled]="resending || !target">
        {{ resending ? 'Resending…' : 'Resend code' }}
      </button>
    </form>

    <a [routerLink]="['/login']" class="vo-back-link" *ngIf="!verified">Back to sign in</a>
    <button type="button" class="vo-btn vo-btn--primary" *ngIf="verified" (click)="backToLogin()">
      Go to sign in
    </button>
  </div>
</div>

